import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import addCarTypeServices from '@src/services/addNewCar/addCarType.services';
import uniqBy from 'lodash/uniqBy';
import map from 'lodash/map';

export const getCustomerVousList = createAsyncThunk(
  'getCustomerVousList',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customer = await getState().customer;
      const customerId = customer?.selectedCustomer?.customerId;
      const { data } = await addCarTypeServices.getCustomerVousList({ customerId });
      const uniqArray = uniqBy(data, (item) => item.vouId);
      const newCustomerVousList = map(uniqArray, (data) => ({
        customerId: data.customerId,
        vouId: data.vouId,
        vouName: data.vouName,
        segmentId: data.segmentId,
      }));
      return newCustomerVousList;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getVehicleDeviceTypeList = createAsyncThunk(
  'getVehicleDeviceTypeList',
  async ({ customerId, vouId }, { rejectWithValue }) => {
    try {
      const { data } = await addCarTypeServices.getVehicleDeviceTypeList({ customerId, vouId });
      const newDeviceTypeList = map(data, (item) => ({
        deviceTypeId: item.deviceTypeId,
        deviceTypeName: item.deviceTypeName,
        deviceTypeLabel: item.deviceTypeLabel,
        vouId: item.vouId,
      }));
      return newDeviceTypeList;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const incrementActiveStep = () => (dispatch, getState) => {
  const { activeStep } = getState().addCarType;
  dispatch(setActiveStep(activeStep + 1));
};

export const decrementActiveStep = () => (dispatch, getState) => {
  const { activeStep } = getState().addCarType;
  dispatch(setActiveStep(activeStep - 1));
};

const initialState = {
  activeStep: 0,
  customerVousList: [],
  vehicleDeviceTypeList: [],
  selectCustomerVousList: {},
  selectVehicleDeviceTypeList: {},
  selectVehicleDeviceType: null,
  selectVehicleProviderType: null,
  loading: {
    customerVousList: false,
    vehicleDeviceTypeList: false,
    activeStep: false,
  },
  demandNo: 0,
};

export const addCarTypeSlice = createSlice({
  name: 'addCarType',
  initialState,
  reducers: {
    setSelectVehicleDeviceType: (state, action) => {
      state.selectVehicleDeviceType = action.payload;
    },
    setSelectVehicleDeviceTypeList: (state, action) => {
      state.selectVehicleDeviceTypeList = action.payload;
    },
    setSelectVehicleProviderType: (state, action) => {
      state.selectVehicleProviderType = action.payload;
    },
    setSelectCustomerVousList: (state, action) => {
      state.selectCustomerVousList = action.payload;
    },
    resetCurrentLoadAddNewCarType: (state) => {
      return initialState;
    },
    setActiveStep: (state, action) => {
      state.loading.activeStep = true;
      state.activeStep = action.payload;
    },
    changeDemandNo: (state, action) => {
      state.demandNo = action.payload;
    },
    finishLoadingStep: (state) => {
      state.loading.activeStep = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerVousList.pending, (state) => {
        state.loading.customerVousList = true;
      })
      .addCase(getCustomerVousList.fulfilled, (state, action) => {
        state.loading.customerVousList = false;
        state.customerVousList = action?.payload || [];
      })
      .addCase(getCustomerVousList.rejected, (state) => {
        state.loading.customerVousList = false;
        state.customerVousList = [];
      })
      .addCase(getVehicleDeviceTypeList.pending, (state) => {
        state.loading.vehicleDeviceTypeList = true;
      })
      .addCase(getVehicleDeviceTypeList.fulfilled, (state, action) => {
        state.loading.vehicleDeviceTypeList = false;
        state.vehicleDeviceTypeList = action?.payload || [];
        const selectedDeviceTypeId =
          typeof state.selectVehicleDeviceType === 'object'
            ? state.selectVehicleDeviceType?.deviceTypeId
            : state.selectVehicleDeviceType;
        const selectedDeviceType = state.vehicleDeviceTypeList.find(
          (item) => item.deviceTypeId === selectedDeviceTypeId,
        );
        if (selectedDeviceType) {
          state.selectVehicleDeviceTypeList = selectedDeviceType;
        }
      })
      .addCase(getVehicleDeviceTypeList.rejected, (state) => {
        state.loading.vehicleDeviceTypeList = false;
        state.vehicleDeviceTypeList = [];
      });
  },
});

export const {
  setSelectVehicleProviderType,
  setSelectVehicleDeviceType,
  setSelectVehicleDeviceTypeList,
  setSelectCustomerVousList,
  resetCurrentLoadAddNewCarType,
  setActiveStep,
  finishLoadingStep,
  changeDemandNo,
} = addCarTypeSlice.actions;
